//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//验证码组件
import photoCode from "@/components/code/index";
import { login, getLoginPhoneValidCode } from "@/assets/api/dataBase.js";
import { utils} from "@/assets/utils/utils.js"
import dbmap from "@/assets/dbs/hashmap.js"
import axios from 'axios'
export default {
    components: {
        photoCode
    },
    data() {
        return {
            isDisabled: true,
            isAllRrquridSuccess: false,
            toastMsg: '',
            hint: "发送验证码",
            photoCode: '',
            mobilPhone: "",
            getCursor: true, //验证码不可点击样式
            bindPhotoTxt: 'waring',
            isBindPhotoTxtShow: false,
            isBindPhotoError: false,
            photoCodeBool: false,
            verifyCode: '',
            // 验证码
            valiCodeParams: {
                mobile: "",
                productCode:dbmap.get('productCode'),
                bankCode: dbmap.get('bankCode')
            },
            loginParams: {
                countryCode: "CN",
                mobile: "18917309999", //this.mobilePhone
                countryNo: "86",
                projectId: "HSBC", //项目ID
                verifyCode: '',
                productCode:dbmap.get('productCode'),
                bankCode: dbmap.get('bankCode')
            },
            bankCode: dbmap.get('bankCode'),
            //倒计时
            countdown: {
                timer: null,
                count: null,
                TIME_COUNT: 120,
                counts: ""
            },
            // 图形验证码
            uuId: "",
            verCodeErrorText: "",
            isVerCodeError: false,
            getVerCode: false,
            verCode:"",
            imgSrc: "",
            getCursorCode: true,
        };
    },
    mounted() {
        this.countdown.counts = this.hint;
        if(!this.bankCode){
            this.$router.push('/index')
        }
        this.getImage();
    },
    methods: {
        // 获取图形验证码
        getImage(){
           let url =  process.env.BASE_API2 +'image/signCaptcha'

            axios({
                method: 'post',
                url: url,
                data: {}
            }).then(result=>{
                console.log('result',result);
                this.imgSrc = result.data.responseData.verCode;
                this.uuId = result.data.responseData.uuId;
            })
        },
        verCodeChange(){
            if(this.verCode != ""){
                this.isVerCodeError = false
                this.getCursorCode  = false
            }else{
                this.isVerCodeError = true
                this.getCursorCode = true
                this.isBindPhotoError = false
                this.isAllSuccess()
            }
        },
        btnBack(){
            this.$router.push('/index')
        },
        getPhotoCode(val) {
          this.loginParams.verifyCode = val;      // 判断是否全部为空
        },
        //验证码校验
        verPhotoCode(){
            if(this.loginParams.verifyCode.length !== 6){
                this.photoCodeBool = true
                this.isBindPhotoError = true
                this.toastMsg = '验证码位数不够！'
                this.isAllSuccess()
                return false
            }else{
                this.photoCodeBool = false
                this.isBindPhotoError = false
                this.toastMsg = 'waring'
                this.isAllSuccess()
                return true
            }
        },
        isAllSuccess(){
            if(this.isBindPhotoError === false && this.isBindPhotoTxtShow === false){
                this.isAllRrquridSuccess = false
                return true
            }else{
                this.isAllRrquridSuccess = true
                window.scrollTo(0, 0);
                return false
            }
        },
        getdata() {
            this.loginParams.mobile = this.mobilPhone;
            login(this.loginParams).then(result => {
                if (result.responseCode === "000000") {
                    dbmap.set('application_id',result.responseData.loanOrderCode)
                    var message = utils.routerJump.returnUrl(result.responseData.fbCode);
                    var url = message.url;
                    this.$router.push({
                        path: url,
                        query: {
                            code: result.responseData.fbCode,
                            loanOrderCode: result.responseData.loanOrderCode,
                            fromType: result.responseData.fromType,
                            rejectDueDate:result.responseData.rejectDueDate || '',//审批拒绝日期提示
                            reApplyBtn:result.responseData.reApplyBtn || ''//审批拒绝按钮显示不显示
                        }
                    })
                } else if (result.responseCode === "000405") {
                    this.isBindPhotoError = true;
                    this.isAllSuccess()
                    this.toastMsg = result.responseMessage;
                }
            });
        },
        login() {
            this.portalType = "login";
            this.verMobilePhone(1)
            this.verPhotoCode()
            let isver = this.isAllSuccess()
            if(isver){
                this.getdata();
            }
        },
        register() {
            this.portalType = "register";
            this.getdata();
        },
        getVerifyCode() {
            //是否在倒计时
            if (this.countdown.counts === this.hint) {
                this.valiCodeParams.mobile = this.mobilPhone;
                this.valiCodeParams.verCode =  this.verCode;
                this.valiCodeParams.uuId =  this.uuId;
                getLoginPhoneValidCode(this.valiCodeParams).then(result => {
                    if(result.responseCode === "000000"){
                        this.isDisabled = false;
                        
                        //开始倒计时
                        this.countdownTime();
                        // this.showToast("验证码获取成功！") 尼古拉斯说这个提示不要
                        // clearInterval(this.countdown.timer);
                    }
                });
            }
        },
        // 倒计时 方法
        countdownTime() {
            if (!this.countdown.timer) {
                //开始计时  按钮不可点击
                this.getCursorCode = true;
                this.getCursor = true;
                //初始化 计时器时间
                this.countdown.count = this.countdown.TIME_COUNT;
                this.countdown.timer = setInterval(() => {
                    if (
                        this.countdown.count > 0 &&
                        this.countdown.count <= this.countdown.TIME_COUNT
                    ) {
                        this.countdown.counts = "重发验证码（"+ this.countdown.count + "s）";
                        this.countdown.count--;
                    } else {
                        //计时结束 按钮可以点击
                        this.getCursorCode = false;
                        this.getCursor = false;
                        
                        clearInterval(this.countdown.timer);
                        this.countdown.timer = null;
                        this.countdown.counts = this.hint;
                    }
                }, 1000);
            }
        },
        // 验证手机号码
        verMobilePhone(e){
            if(e.target){
                this.mobilPhone = e.target.value
            }
            this.getCursor = true;
            this.isBindPhotoTxtShow = true;
            let reg=11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if(this.mobilPhone==''){
                this.bindPhotoTxt = '手机号码不能为空！'
                this.isAllSuccess()
                return;
            }else if(this.mobilPhone && this.mobilPhone.length < 11){
                this.bindPhotoTxt = '手机号码位数不够！'
                this.isAllSuccess()
                return;
            }else if(!reg.test(this.mobilPhone)){
                this.bindPhotoTxt = '手机号码格式有误！'
                this.isAllSuccess()
                return;
            }else if(this.countdown.counts !== this.hint){
                this.isBindPhotoTxtShow = false;
                this.bindPhotoTxt = 'waring';
                this.getCursor = true;
                return;
            }else{
                this.isBindPhotoTxtShow = false;
                this.bindPhotoTxt = 'waring';
                this.getCursor = false;
                this.isAllSuccess()
            }
        },
    }
};



// WEBPACK FOOTER //
// ./src/view/login.vue